module.exports = __webpack_public_path__ + "img/campaign-coming-soon.c75d1456.jpg";